/**
 * @summary PAGES: This is any page for a microsite, https://domain.com/content/{slug}
 * This points to wordpress Pages content types
 */
import React from 'react';
import PageContainer from 'components/global/PageContainer';
import PageSectionLayout from 'components/global/PageSectionLayout';
import { pagePropsType } from 'utils/propTypes';
import getContentPageProps from 'app-requests/content-type-loaders/content-page-props';
import {
  getQuestionBank,
  getQuestionnaires,
} from 'app-requests/triadmsRequests';
import handleServerRedirect from 'utils/handleServerRedirect';
import { APIError } from 'utils/errors/APIError';
import { APITransformError } from 'utils/errors/APITransformError';
import { LogError } from 'utils/logging';
import { notFoundRedirect, serverMaintenanceRedirect, SITE_TYPE } from 'consts';

function ContentPage(props) {
  const {
    pageProps: { pageSections, ...globalPageProps },
  } = props;

  return (
    <PageContainer pageProps={globalPageProps}>
      <PageSectionLayout pageSections={pageSections} isLanding />
    </PageContainer>
  );
}

export async function getServerSideProps(context) {
  try {
    const { req, res, query } = context;
    const domain = req.headers.host;

    const pageProps = await getContentPageProps({ req, res, query });

    let questionBankMap;
    let questionnaires = {};

    if (pageProps.meta.siteType === SITE_TYPE.CLICK_PORTAL) {
      questionBankMap = await getQuestionBank(req.redisHelpers, req.cookies);
      questionnaires = await getQuestionnaires({
        questionBankMap,
        domain,
        schoolCode: pageProps.meta.schoolCode,
        formSettings: pageProps.formSettings.questionnaires,
        redisHelpers: req.redisHelpers,
      });
    }

    return {
      props: {
        ...pageProps,
        questionnaire: {},
        questionnaires,
      },
    };
  } catch (error) {
    if (error.statusCode === 404) {
      handleServerRedirect(notFoundRedirect, context);
      return { props: {} };
    }

    if (error instanceof APIError) {
      LogError(error, {
        statusCode: error.statusCode,
        endpoint: error.endpoint,
        route: 'content/[pages]',
      });
    } else if (error instanceof APITransformError) {
      LogError(error, {
        method: error.method,
        route: 'content/[pages]',
      });
    } else {
      LogError(error, {
        route: 'content/[pages]',
      });
    }

    if (process.env.NODE_ENV === 'development') {
      throw error;
    } else {
      handleServerRedirect(serverMaintenanceRedirect, context, 302);
    }
    return { props: {} };
  }
}

ContentPage.propTypes = {
  pageProps: pagePropsType.isRequired,
};

export default ContentPage;
